import { render, staticRenderFns } from "./loan-ok.vue?vue&type=template&id=1b2b23ef&scoped=true&"
import script from "./loan-ok.vue?vue&type=script&lang=js&"
export * from "./loan-ok.vue?vue&type=script&lang=js&"
import style0 from "./loan-ok.vue?vue&type=style&index=0&id=1b2b23ef&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b23ef",
  null
  
)

export default component.exports